import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(//console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// Aggiornamenti del service worker: se all'avvio della pagina ce n'e' uno in attesa
// lo applichiamo subito (non c'e' ancora nessuno stato da perdere). Durante la sessione
// NON ricarichiamo mai da soli, perche' una partita o la creazione della stanza in Home
// andrebbero perse: l'aggiornamento viene applicato alla prossima visita della Home.
serviceWorkerRegistration.register({
  onUpdate: (registration, info) => {
    serviceWorkerRegistration.setPendingUpdate(registration);
    if (info && info.atStartup) {
      serviceWorkerRegistration.applyPendingUpdate();
    }
  },
});